export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/f06aa47dba46417578dfc8b9ab5cf8b2.jpg" 
          alt="ACE Consultancy Africa Team" 
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3 space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight">
                ACE Consultancy Africa
              </h1>
              <p className="text-3xl lg:text-4xl font-serif italic text-[#D4AF37]">
                Professional Business Solutions
              </p>
              <p className="text-lg text-white/80 max-w-2xl leading-relaxed">
                Empowering African Businesses Through Strategic Consulting & Comprehensive Services
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <button onClick={() => scrollToSection('services')} className="bg-[#D4AF37] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#C19B2E] transition-all flex items-center gap-2 whitespace-nowrap">
                Explore Our Services
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              <button onClick={() => scrollToSection('about')} className="border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap">
                Learn More
              </button>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="bg-gray-900/50 backdrop-blur-md rounded-3xl p-8 space-y-6">
              <div className="flex items-center gap-4 p-4 bg-white/10 rounded-2xl hover:bg-white/20 transition-all cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-base">Home Security</div>
                  <div className="text-white/70 text-sm">Consulting</div>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-white/10 rounded-2xl hover:bg-white/20 transition-all cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full">
                  <i className="ri-line-chart-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-base">Market Research</div>
                  <div className="text-white/70 text-sm">Analysis</div>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-white/10 rounded-2xl hover:bg-white/20 transition-all cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full">
                  <i className="ri-shopping-bag-3-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-base">Asset Sales</div>
                  <div className="text-white/70 text-sm">Platform</div>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-white/10 rounded-2xl hover:bg-white/20 transition-all cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full">
                  <i className="ri-file-text-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-base">Grant Writing</div>
                  <div className="text-white/70 text-sm">Proposals</div>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-white/10 rounded-2xl hover:bg-white/20 transition-all cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full">
                  <i className="ri-team-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-base">Recruiting</div>
                  <div className="text-white/70 text-sm">Agency</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
